import { FileInput, FileType } from "components/FileInput/FileInput";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { getLocalFileKey } from "utils/getLocalFileKey";
import { toLocalDropFile } from "utils/toLocalDropFile";
import { FINALLY_FILE_ACCEPT } from "./constants";
import { FinallyAddDetailsFormValues } from "./ImportFinallyContext";

const JE_HELPER_TEXT =
  "Upload every Journal Entries export from Finally. Files must cover separate date ranges — we merge them in date order.";

export const FinallyJournalEntriesInput = () => {
  const { values, errors, setFieldValue, setFieldError } =
    useTypedFormikContext<FinallyAddDetailsFormValues>();

  const jeFiles = values.je_files;
  const error = errors.je_files;
  const dropFiles = jeFiles.map(toLocalDropFile);

  const handleDrop = (droppedFiles: FileType[]) => {
    const existingKeys = new Set(jeFiles.map(getLocalFileKey));
    const newFiles = droppedFiles
      .filter((file): file is File => file instanceof File)
      .filter((file) => !existingKeys.has(getLocalFileKey(file)));

    setFieldError("je_files", undefined);
    void setFieldValue("je_files", [...jeFiles, ...newFiles]);
  };

  const handleDelete = (_: React.MouseEvent<HTMLButtonElement>, i: number) => {
    setFieldError("je_files", undefined);
    void setFieldValue(
      "je_files",
      jeFiles.filter((_file, index) => index !== i)
    );
  };

  return (
    <div className="t-flex t-flex-col">
      <FileInput
        label="Journal Entries"
        accept={FINALLY_FILE_ACCEPT}
        files={dropFiles}
        onDrop={handleDrop}
        onDelete={handleDelete}
        hasError={Boolean(error)}
        description={JE_HELPER_TEXT}
        multiple
        required
      />
      {typeof error === "string" && (
        <div className="t-mt-1.5 t-text-body-sm t-text-red">{error}</div>
      )}
    </div>
  );
};
